import http from '@/http'
import { DraftPage, Params } from '@/interfaces/admin'

export async function getDraftPage (pageId: number, params: Params): Promise<DraftPage> {
  const { data } = await http.get(`/admin/draft-pages/pages/${pageId}`, { params })
  return data
}
